<template>
  <div
    id="app"
    :class="{'showBanner': showFloatBanner }">
 <!--   <FloatBanner v-if="showFloatBanner"></FloatBanner> -->
    <router-view />
  </div>
</template>

<script>
import authStore from '@/store/auth';
// import FloatBanner from '@/components/FloatBanner';

export default {
//  components: { FloatBanner },
  created() {
    const { magiccubeToken } = this.$route.query;
    if (magiccubeToken) {
      authStore.commit('SET_ACCESS_TOKEN', decodeURIComponent(magiccubeToken));
    }
  },
  computed: {
    showFloatBanner() {
      const { meta, name } = this.$route;
      if (!name) return false;
      const hideBanner = (meta && meta.hideBanner);
      return !this.$bridge.device.swjApp && !hideBanner;
    },
  },
};
</script>

<style lang="less">
#app {
  background-color: @white;
}
.showBanner {
  /*padding-top: 104px; */
}
/* 判断iPhone 将 footer 的 padding-bottom 填充到最底部 */
@supports (bottom: env(safe-area-inset-bottom)){
  .showBanner {
    /* margin-bottom: constant(safe-area-inset-bottom, 20px);
    margin-bottom: env(safe-area-inset-bottom, 20px);
    margin-bottom: var(safe-area-inset-bottom, 20px); */
  }
}
</style>
